module.exports = __webpack_public_path__ + "images/logo-paid-invoice.png";